import { render, staticRenderFns } from "./MoskitoTabs.vue?vue&type=template&id=7d278485&"
import script from "./MoskitoTabs.vue?vue&type=script&lang=js&"
export * from "./MoskitoTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports